import React from 'react';
import { Shield, Lock, DollarSign, Clock, CheckCircle, Headphones } from 'lucide-react';

const TrustSafety = () => {
  const trustFeatures = [
    {
      icon: Lock,
      title: 'Enkripsi SSL',
      description: 'Enkripsi 256-bit level bank melindungi data kamu',
      color: '#E31837'
    },
    {
      icon: Shield,
      title: 'Keamanan Level Bank',
      description: 'Dana kamu tetap di akun broker kamu sendiri',
      color: '#FF1744'
    },
    {
      icon: DollarSign,
      title: 'Modal Kamu, Kontrol Kamu',
      description: 'Kami gak pernah sentuh uang kamu. Kontrol penuh selalu.',
      color: '#E31837'
    },
    {
      icon: Clock,
      title: 'Tarik Kapan Saja',
      description: 'Tanpa lock-in. Akses dana kamu 24/7',
      color: '#C4122F'
    },
    {
      icon: CheckCircle,
      title: 'Broker Teregulasi',
      description: 'Partner cuma dengan broker berlisensi & teregulasi',
      color: '#FF1744'
    },
    {
      icon: Headphones,
      title: 'Support 24/7',
      description: 'Support manusia real kapan pun kamu butuh',
      color: '#E31837'
    }
  ];

  return (
    <div style={{
      padding: '100px 0',
      background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Red accent lines */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        background: 'linear-gradient(90deg, transparent, #E31837, transparent)'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '3px',
        background: 'linear-gradient(90deg, transparent, #E31837, transparent)'
      }}></div>
      
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 24px',
            background: 'linear-gradient(135deg, rgba(227, 24, 55, 0.2), rgba(255, 23, 68, 0.1))',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid rgba(227, 24, 55, 0.3)',
            boxShadow: '0 0 30px rgba(227, 24, 55, 0.3)'
          }}>
            <Shield style={{ 
              width: '40px', 
              height: '40px', 
              color: '#FF1744',
              filter: 'drop-shadow(0 0 10px rgba(255, 23, 68, 0.5))'
            }} />
          </div>
          <h2 style={{
            fontSize: window.innerWidth <= 768 ? '2rem' : window.innerWidth <= 1024 ? '2.5rem' : '3rem',
            fontWeight: 700,
            background: 'linear-gradient(135deg, #FFFFFF 0%, #FF1744 50%, #E31837 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '16px',
            fontFamily: "'Space Grotesk', sans-serif",
            padding: window.innerWidth <= 768 ? '0 16px' : '0'
          }}>
            Keamanan Kamu Prioritas Kami
          </h2>
          <p style={{ 
            fontSize: window.innerWidth <= 768 ? '1rem' : '1.125rem', 
            color: 'rgba(255, 255, 255, 0.8)', 
            maxWidth: '600px', 
            margin: '0 auto', 
            lineHeight: 1.6,
            padding: window.innerWidth <= 768 ? '0 16px' : '0'
          }}>
            Trading dengan percaya diri. Dana dan data kamu dilindungi oleh keamanan terdepan di industri.
          </p>
        </div>

        {/* Trust Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : window.innerWidth <= 1024 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
          gap: window.innerWidth <= 768 ? '20px' : '32px',
          marginBottom: '64px'
        }}>
          {trustFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} style={{
                background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.9) 0%, rgba(30, 30, 30, 0.8) 100%)',
                border: '2px solid rgba(227, 24, 55, 0.3)',
                borderRadius: '16px',
                padding: window.innerWidth <= 768 ? '32px 24px' : '40px 32px',
                textAlign: 'center',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-12px)';
                e.currentTarget.style.borderColor = '#E31837';
                e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.8), 0 0 40px rgba(227, 24, 55, 0.4)';
                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(227, 24, 55, 0.1) 0%, rgba(30, 30, 30, 0.9) 100%)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(227, 24, 55, 0.3)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(20, 20, 20, 0.9) 0%, rgba(30, 30, 30, 0.8) 100%)';
              }}
              >
                {/* Red accent corner */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, transparent 50%, rgba(227, 24, 55, 0.1) 50%)',
                  borderRadius: '0 16px 0 0'
                }}></div>
                
                <div style={{
                  width: '72px',
                  height: '72px',
                  borderRadius: '16px',
                  margin: '0 auto 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: `linear-gradient(135deg, ${feature.color}20, ${feature.color}10)`,
                  border: `2px solid ${feature.color}40`,
                  position: 'relative',
                  zIndex: 1
                }}>
                  <Icon style={{ 
                    width: '36px', 
                    height: '36px', 
                    color: feature.color,
                    filter: `drop-shadow(0 0 8px ${feature.color}80)`
                  }} />
                </div>
                <h3 style={{ 
                  fontSize: '1.25rem', 
                  fontWeight: 700, 
                  color: '#FFFFFF', 
                  marginBottom: '12px',
                  position: 'relative',
                  zIndex: 1
                }}>
                  {feature.title}
                </h3>
                <p style={{ 
                  fontSize: '0.9375rem', 
                  color: 'rgba(255, 255, 255, 0.7)', 
                  lineHeight: 1.6,
                  position: 'relative',
                  zIndex: 1
                }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustSafety;
